import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';
import { MediaUpload } from '.';

export type V = {
  '@id': string;
  '@type': 'MyClinicianStatus';
  hasUnreadMessages: boolean;
  hasAppointmentsToday: boolean;
  hasNewClients: boolean;
  user: {
    name: string;
    displayPicture: MediaUpload.BaseView | null;
    clinicianProfile: {
      hasEditAccess: boolean;
      appointmentDuration: number;
      appointmentBuffer: number;
    } | null;
    type: string;
  };
};

export function useReadItem(options?: ReadConfig) {
  return useApiRead<V>(`/my-clinician-status`, options);
}
